import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";

const Overview = lazy(() =>
  import("./pages/Overview").then((mod) => ({ default: mod.Overview })),
);
const Distribution = lazy(() =>
  import("./pages/Distribution").then((mod) => ({
    default: mod.Distribution,
  })),
);
const GameAnalysis = lazy(() =>
  import("./pages/GameAnalysis").then((mod) => ({
    default: mod.GameAnalysis,
  })),
);
const Devices = lazy(() =>
  import("./pages/Devices").then((mod) => ({ default: mod.Devices })),
);
const DeathLocations = lazy(() =>
  import("./pages/DeathLocations").then((mod) => ({ default: mod.DeathLocations })),
);
const Detections = lazy(() =>
  import("./pages/Detections").then((mod) => ({ default: mod.Detections })),
);
const Sessions = lazy(() =>
  import("./pages/Sessions").then((mod) => ({ default: mod.Sessions })),
);
const SessionDetail = lazy(() =>
  import("./pages/SessionDetail").then((mod) => ({
    default: mod.SessionDetail,
  })),
);

export default function App() {
  return (
    <Suspense fallback={<div className="loading">Loading...</div>}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Overview />} />
          <Route path="distribution" element={<Distribution />} />
          <Route path="analysis" element={<GameAnalysis />} />
          <Route path="devices" element={<Devices />} />
          <Route path="death-locations" element={<DeathLocations />} />
          <Route path="detections" element={<Detections />} />
          <Route path="sessions" element={<Sessions />} />
          <Route path="sessions/:id" element={<SessionDetail />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
